module.exports = __webpack_public_path__ + "img/spoken-selected-green.f9569817.svg";